import React from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AlbetheineEye from "@/components/AlbetheineEye";
import CelticOrnament from "@/components/CelticOrnament";

export default function Contact() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <section className="relative max-w-3xl mx-auto px-6 md:px-10 pt-20 md:pt-28 pb-24 text-center">
          <AlbetheineEye size={120} className="mx-auto opacity-90 flicker" />
          <div className="eyebrow mt-6">SPEAK WITH US</div>
          <h1
            className="font-cinzel text-cream text-4xl md:text-5xl mt-5 leading-tight tracking-wide"
            data-testid="contact-page-title"
          >
            Contact <span className="gold-gradient-text">Tapped In Clarity</span>
          </h1>
          <CelticOrnament size={70} className="mx-auto mt-6 opacity-70" />

          <p className="text-cream-soft mt-10 leading-relaxed text-lg">
            Whether you have a question about <em>Albetheine&apos;s Oracle</em>, a
            booking enquiry, a refund request, or just a quiet wondering —
            every message is read personally.
          </p>

          <div className="gold-divider my-10 max-w-xs mx-auto" />

          <div className="font-cinzel text-gold text-[0.72rem] tracking-[0.32em] mb-4">
            EMAIL
          </div>
          <a
            href="mailto:tappedinclarity@gmail.com"
            className="btn-gold inline-flex"
            data-testid="contact-email-btn"
          >
            tappedinclarity@gmail.com
          </a>

          <div className="mt-12 text-cream-soft text-base leading-relaxed">
            <div className="font-cinzel text-gold text-[0.72rem] tracking-[0.32em] mb-3">
              POSTAL ADDRESS
            </div>
            Tapped In Clarity
            <br />
            Sole Trader · United Kingdom
            <br />
            <em className="text-cream-muted text-sm">
              Business address available on written request.
            </em>
          </div>

          <div className="mt-12 text-cream-muted text-xs font-cinzel tracking-[0.28em]">
            · WE AIM TO REPLY WITHIN 3 WORKING DAYS ·
          </div>

          <div className="mt-14">
            <Link to="/" className="btn-ghost" data-testid="contact-back-home">
              Return to Sanctuary
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
